<p-contextMenu
        appendTo="body"
        [model]="contextMenuItems"
></p-contextMenu>